import React, { createContext, useCallback, useEffect, useState } from "react";

export const UserContext = createContext();

const UserContextProvider = (props) => {
  const [currentUser, setCurrentUser] = useState({});
  const [isUserFetched, setIsUserFetched] = useState(false);

  const fetchCurrentUser = useCallback(async () => {
    const token = localStorage.getItem("customToken");
    if (!token) {
      console.debug("No token found");
      return;
    }
    if (isUserFetched || Object.keys(currentUser).length !== 0) {
      console.debug("User already set or fetch already attempted");
      return;
    }

    try {
      console.debug("Fetching current user...");
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/auth/decode_token`,
        {
          method: "POST",
          credentials: "include",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            accept: "application/json",
          },
        }
      );

      if (response.ok) {
        const user = await response.json();
        console.log("Fetched user: ", user);
        setCurrentUser(user.data);
        setIsUserFetched(true);
      } else {
        console.error("Failed to fetch user: ", response.statusText);
      }
    } catch (error) {
      console.error("Failed to fetch user:", error);
    }
  }, [currentUser, isUserFetched]);

  useEffect(() => {
    if (!isUserFetched) {
      fetchCurrentUser();
    }
  }, [fetchCurrentUser]);

  return (
    <UserContext.Provider value={{ currentUser, setCurrentUser }}>
      {props.children}
    </UserContext.Provider>
  );
};

export default UserContextProvider;
